module.exports = __webpack_public_path__ + "img/img-device.c37a57c0.png";